import getRouter from '@/router/getRouter.ts'

export default () => {
  const router = getRouter()
  router.push({ name: 'Paywall' })
}
